import { render, staticRenderFns } from "./CancelOrderByEmail.vue?vue&type=template&id=8605bde0&scoped=true"
import script from "./CancelOrderByEmail.vue?vue&type=script&lang=js"
export * from "./CancelOrderByEmail.vue?vue&type=script&lang=js"
import style0 from "./CancelOrderByEmail.vue?vue&type=style&index=0&id=8605bde0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8605bde0",
  null
  
)

export default component.exports